import { inject, Injectable } from '@angular/core';
import { MyArvatoEnvironment } from '@myarvato/shared/models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserTabDto } from '../models/user-tab-dto';

interface TabsRequestOptions {
  showGlobalLoading?: boolean;
}

@Injectable({
  providedIn: 'root',
})

/**
 * Service to manage user tabs in application.
 */
export class CustomizationTabsService<T> {
  // Injections
  private readonly environment = inject(MyArvatoEnvironment);
  private readonly httpClient = inject(HttpClient);

  // Fields
  private readonly baseUrl = `${this.environment.url.api}Customization/Tabs`;

  public getTabs(tabsContext: string, options?: TabsRequestOptions): Observable<UserTabDto<T>[]> {
    return this.httpClient.get<UserTabDto<T>[]>(`${this.baseUrl}/${tabsContext}`, this.getRequestOptions(options));
  }

  public addTab(tab: UserTabDto<T>, options?: TabsRequestOptions): Observable<UserTabDto<T>> {
    return this.httpClient.post<UserTabDto<T>>(`${this.baseUrl}`, tab, this.getRequestOptions(options));
  }

  public deleteTab(tabId: string, options?: TabsRequestOptions): Observable<UserTabDto<T>> {
    return this.httpClient.delete<UserTabDto<T>>(`${this.baseUrl}/${tabId}`, this.getRequestOptions(options));
  }

  public deleteAllTabsOfContext(tabsContext: string, options?: TabsRequestOptions): Observable<UserTabDto<T>[]> {
    return this.httpClient.delete<UserTabDto<T>[]>(`${this.baseUrl}/${tabsContext}`, this.getRequestOptions(options));
  }

  private getRequestOptions({ showGlobalLoading = false }: TabsRequestOptions = {}) {
    let headers = new HttpHeaders({
      'x-skip-all-interceptor-handling': 'true',
      'x-error-message-target-key': 'none',
    });

    if (!showGlobalLoading) {
      headers = headers.set('x-skip-loading-interceptor-handling', 'true');
    }

    return { headers: headers };
  }
}
